import { ComponentAPI } from '@philips-emr/tws-core';

export default class HpmsTextHtmlAPI extends ComponentAPI {
  setData(data: string ): void {
    this.setState( { data } );
  }
}
